var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMur2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.955 33.0096C150.785 50.6596 192.595 68.3396 234.435 85.9896C233.785 110.53 233.155 135.07 232.505 159.61C190.115 140.54 147.725 121.46 105.345 102.39C106.545 79.2496 107.755 56.1296 108.955 33.0096Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.245 38.0697C138.065 45.2397 154.885 52.3796 171.705 59.5096C192.605 68.3596 213.515 77.1896 234.445 85.9996C233.795 110.54 233.165 135.08 232.515 159.62C195.495 143.11 158.465 126.59 121.445 110.08C121.385 86.0796 121.315 62.0697 121.255 38.0697H121.245Z",
    fill: "#FEE4E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3051 159.9L135.045 217.31L232.515 160.31C214.945 151.5 196.555 142.71 177.355 134.02C158.245 125.38 139.585 117.41 121.445 110.07C106.345 117.54 90.9351 125.45 75.2551 133.83C59.0351 142.5 43.3851 151.21 28.3151 159.9H28.3051Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.325 80.8094C226.375 82.5494 230.395 84.2594 234.435 85.9894C232.455 106.969 230.485 127.919 228.485 148.889C192.795 169.479 157.125 190.079 121.435 210.669V126.639C155.055 111.369 188.675 96.0794 222.325 80.8094Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.045 133.959V217.31L121.435 210.67V126.64L135.045 133.959Z",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.045 217.31C167.535 198.31 200.025 179.31 232.515 160.31C233.165 135.53 233.795 110.75 234.445 85.9696L135.055 133.94V217.31H135.045Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.955 33.0096C113.045 34.6896 117.145 36.3797 121.235 38.0597C121.015 56.3897 120.805 74.7397 120.585 93.0697C85.565 113.28 50.5751 133.48 15.5551 153.66V75.0597C46.6951 61.0397 77.815 47.0196 108.955 33.0096Z",
    fill: "#72D09A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3048 81.9194V159.899L15.5648 153.659V75.0594L28.3048 81.9194Z",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3207 159.911C59.3607 143.291 90.4107 126.701 121.451 110.081C121.381 86.0712 121.301 62.0611 121.261 38.0511C90.2907 52.6711 59.2907 67.2911 28.3207 81.9111V159.911Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMur2);
export default __webpack_public_path__ + "static/media/mur2.5c46cd43fc52ebc4a69f8e0886c4ab33.svg";
export { ForwardRef as ReactComponent };